import {
  Drawer,
  List,
  ListItemText,
  Box,
  ListItemButton,
} from '@mui/material';
import { Link, useLocation, matchPath, Outlet } from 'react-router-dom';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
// Constants
const DRAWER_WIDTH = 240;

// Drawer styles
const drawerStyles = {
  width: DRAWER_WIDTH,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
    backgroundColor: 'rgb(232, 230, 231)',
  },
};

// Main content styles
const mainStyles = {
  flexGrow: 1,
};

// Navigation Item Component
const NavItem = memo(({ path, label, isSelected }: any) => (
  <ListItemButton
    component={Link}
    to={path}
    selected={isSelected}
    sx={{
      '&.Mui-selected': {
        bgcolor: 'rgb(220, 218, 219)',
        height: '40px',
        '&:hover': {
          bgcolor: 'rgb(220, 218, 219)',
        },
        '& .MuiListItemText-primary': {
          fontWeight: '500',
        },
      },
      '&:hover': {
        bgcolor: 'unset',
      },
    }}
  >
    <ListItemText
      primary={label}
      sx={{
        '& .MuiTypography-root': {
          fontSize: '14px',
        }
      }}
    />
  </ListItemButton>
));

const AssetManagement = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation() as any

  return (
    <Box sx={{
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      '& main': {
        flexGrow: 1,
        overflowY: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    }}>
      <Drawer
        sx={drawerStyles}
        variant="permanent"
        anchor="left"
      >
        <List component="nav" disablePadding style={{ marginTop: 50 }}>
          <NavItem
            path="/asset/assets"
            label={t('00_01_asset')}
            isSelected={matchPath('/asset/assets', pathname) !== null}
          />
          <NavItem
            path="/asset/transactions"
            label={t('34_00_transactions')}
            isSelected={matchPath('/asset/transactions', pathname) !== null}
          />
        </List>
      </Drawer>

      <Box component="main" sx={mainStyles}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AssetManagement;